import { render, staticRenderFns } from "./ApplicationProcessCard.vue?vue&type=template&id=10e864e4&scoped=true"
import script from "./ApplicationProcessCard.vue?vue&type=script&lang=js"
export * from "./ApplicationProcessCard.vue?vue&type=script&lang=js"
import style0 from "./ApplicationProcessCard.vue?vue&type=style&index=0&id=10e864e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e864e4",
  null
  
)

export default component.exports